// src/data/reviewsByPage.js

/**
 * rating can be: 5, 4, 3.5 etc
 * Keep 5 reviews per page (your rule)
 */
export const reviewsByPage = {
  default: [
    { name: "John D.", text: "Reliable taxi service — on time and professional.", rating: 5 },
    { name: "Sarah M.", text: "Smooth booking and friendly driver. Great value.", rating: 4 },
    { name: "Ahmed K.", text: "Affordable and stress-free airport transfer.", rating: 5 },
    { name: "Priya S.", text: "Clear pricing and quick confirmation. Would use again.", rating: 4.5 },
    { name: "Tom W.", text: "Easy to book and punctual pickup.", rating: 4 },
  ],

  "/": [
    { name: "Lisa G.", text: "Made Heathrow pickup stress-free and cheaper than Uber.", rating: 5 },
    { name: "Rohan S.", text: "Instant fare checks saved me from surge pricing — very helpful.", rating: 5 },
    { name: "Emily P.", text: "I liked that I could see taxi prices against other options before booking. Felt transparent and stress-free.", rating: 5 },
    { name: "Mark C.", text: "Everything I needed was on one page — quote, comparisons, and booking.", rating: 4 },
    { name: "Helen T.", text: "The tools actually helped me decide when and how to travel, not just book a ride.", rating: 3.5 },
  ],

  "/heathrow-taxi": [
    { name: "Alex R.", text: "Showed fixed vs app prices so I locked a taxi and skipped surge.", rating: 5 },
    { name: "Priya K.", text: "Door-to-door price with luggage included — avoided airport hassle.", rating: 5 },
    { name: "Samir A.", text: "Loved the no-surge clarity; booked with confidence.", rating: 5 },
    { name: "Georgia L.", text: "Helpful fare ranges and stress notes; easy to decide.", rating: 4 },
    { name: "Owen F.", text: "Good info, wish map pickup hints were a bit clearer.", rating: 3.5 },
  ],

  "/heathrow-minibus-hire": [
    { name: "Nadia R.", text: "Clear Heathrow minibus quote for our family group, with luggage space explained before we booked.", rating: 5 },
    { name: "Marcus T.", text: "The fixed price made our T5 pickup simple and cheaper than splitting into two taxis.", rating: 5 },
    { name: "Aisha K.", text: "Good support for child seats and bags. The driver tracked our delayed flight and kept things calm.", rating: 5 },
    { name: "Ben L.", text: "Useful Heathrow minibus page for comparing 9 and 14 seater options before booking.", rating: 4.5 },
    { name: "Claire M.", text: "Straightforward airport transfer for our group from Heathrow to Windsor. No surge pricing.", rating: 4 },
  ],

  "/heathrow-coach-hire": [
    { name: "Rachel D.", text: "Coach quote for our Heathrow delegation was clear, quick and much easier than splitting the group.", rating: 5 },
    { name: "Imran S.", text: "Good support for a multi-stop company trip from Heathrow. The planning questions were sensible.", rating: 5 },
    { name: "Claire B.", text: "Transparent pricing for our school group, with luggage and waiting time explained before booking.", rating: 5 },
    { name: "Patrick H.", text: "Smooth coach enquiry for a conference transfer. The Heathrow status checks helped with timing.", rating: 4.5 },
    { name: "Nadia K.", text: "Helpful for arranging a larger airport group without chasing several operators.", rating: 4 },
  ],

  "/slough-taxi": [
    { name: "James V.", text: "Showed me Slough → Heathrow fixed fare vs Uber — saved money.", rating: 5 },
    { name: "Maria N.", text: "Helpful baggage notes; avoided a last-minute XL scramble.", rating: 5 },
    { name: "Noor H.", text: "Simple, accurate, and cheaper than I expected for Slough runs.", rating: 5 },
    { name: "Peter B.", text: "Clear estimate and hassle notes; booked in minutes.", rating: 4 },
    { name: "Ella D.", text: "Useful, though I’d like live ETA built in.", rating: 3.5 },
  ],

  "/slough-to-heathrow": [
    { name: "James V.", text: "Fixed Slough to Heathrow fare was clear before booking and the driver arrived on time.", rating: 5 },
    { name: "Maria N.", text: "The Heathrow timing and luggage notes made our early airport run much easier.", rating: 5 },
    { name: "Noor H.", text: "Quick quote from SL1 to Heathrow with no surge pricing. Very straightforward.", rating: 5 },
    { name: "Peter B.", text: "Helpful route page and easy booking for a Heathrow terminal drop-off.", rating: 4 },
    { name: "Ella D.", text: "Good local airport transfer page. Live Heathrow checks were useful.", rating: 4.5 },
  ],

  "/maidenhead-to-heathrow": [
    { name: "Harriet L.", text: "Clear fixed fare from Maidenhead to Heathrow and the driver handled our luggage without fuss.", rating: 5 },
    { name: "Ravi P.", text: "Booked from Maidenhead station to T5 in minutes. The Heathrow status check was useful before leaving.", rating: 5 },
    { name: "Claire B.", text: "Good price clarity for an early SL6 pickup, with no surge pricing to worry about.", rating: 5 },
    { name: "Daniel M.", text: "Easy route page and a smooth airport transfer from Bray to Heathrow.", rating: 4.5 },
    { name: "Nadia R.", text: "Helpful for comparing timing and booking a fixed airport taxi from Maidenhead.", rating: 4 },
  ],

  "/windsor-to-heathrow": [
    { name: "Amelia H.", text: "Booked Windsor Castle to Heathrow T5 with a fixed fare. The pickup point was clear and the driver was early.", rating: 5 },
    { name: "Karan S.", text: "Very easy Windsor to Heathrow booking after a hotel stay. No surge pricing and good luggage space.", rating: 5 },
    { name: "Megan P.", text: "Useful route page for our LEGOLAND trip. We booked a Heathrow transfer for the next morning without hassle.", rating: 5 },
    { name: "Oliver B.", text: "Good local detail for Windsor and Eton pickups, and the live Heathrow checks helped with timing.", rating: 4.5 },
    { name: "Zainab R.", text: "Clear airport transfer quote from Old Windsor to Heathrow. Straightforward and reliable.", rating: 4 },
  ],

  "/burnham-taxi": [
    { name: "Ruth G.", text: "Easy Burnham station pickup and a clear fixed fare before booking.", rating: 5 },
    { name: "Amit P.", text: "Booked from Burnham Beeches Hotel & Spa to Heathrow with no hassle.", rating: 5 },
    { name: "Claire J.", text: "Useful local page for Burnham Beeches and airport taxi options.", rating: 4.5 },
    { name: "Martin S.", text: "Reliable Burnham taxi with good luggage space for our family.", rating: 5 },
    { name: "Nadia K.", text: "The fixed price made our early Heathrow transfer straightforward.", rating: 4 },
  ],

  "/burnham-to-heathrow": [
    { name: "Amit P.", text: "Burnham to Heathrow quote was fixed upfront and the driver arrived on time.", rating: 5 },
    { name: "Ruth G.", text: "Great for Burnham station to T5. Booking was quick and clear.", rating: 5 },
    { name: "Helen B.", text: "Collected from Burnham Beeches Hotel & Spa and handled our bags well.", rating: 5 },
    { name: "Owen M.", text: "Good route page with Heathrow status and sensible timing notes.", rating: 4.5 },
    { name: "Saira D.", text: "No surge pricing and an easy airport transfer from Burnham.", rating: 4 },
  ],

  "/taplow-taxi": [
    { name: "Lucy H.", text: "Taplow station pickup was simple and the fixed fare was clear.", rating: 5 },
    { name: "Raj M.", text: "Booked a taxi from Cliveden to Heathrow after a weekend stay. Smooth service.", rating: 5 },
    { name: "Ben C.", text: "Helpful Taplow local page with station and hotel pickup details.", rating: 4.5 },
    { name: "Mina S.", text: "Good MPV option for our family and luggage from Taplow.", rating: 5 },
    { name: "James A.", text: "Easy local booking around Taplow and Maidenhead Bridge.", rating: 4 },
  ],

  "/taplow-to-heathrow": [
    { name: "Raj M.", text: "Taplow to Heathrow fixed fare was clear and the driver knew the Cliveden pickup well.", rating: 5 },
    { name: "Lucy H.", text: "Booked from Taplow station to Heathrow with no surge pricing.", rating: 5 },
    { name: "Priya V.", text: "Useful route page for checking terminal timing before we left.", rating: 5 },
    { name: "George F.", text: "Good airport transfer from a Thames-side hotel near Taplow.", rating: 4.5 },
    { name: "Aisha R.", text: "Straightforward Taplow to Heathrow booking with luggage space.", rating: 4 },
  ],

  "/ascot-taxi": [
    { name: "Rebecca W.", text: "Booked an Ascot Racecourse pickup for our group and the fixed fare made planning much easier.", rating: 5 },
    { name: "Imran S.", text: "Useful Royal Ascot taxi page with racecourse, station and Heathrow details in one place.", rating: 5 },
    { name: "Charlotte P.", text: "The MPV option helped with hats, bags and a hotel pickup near Ascot.", rating: 5 },
    { name: "Daniel R.", text: "Clear guidance for Ascot station and racecourse pickup timing.", rating: 4.5 },
    { name: "Nina K.", text: "Good local Ascot taxi page before booking our Heathrow transfer.", rating: 4 },
  ],

  "/ascot-to-heathrow": [
    { name: "Rebecca W.", text: "Ascot Racecourse to Heathrow was easy to book and the pickup timing was clear.", rating: 5 },
    { name: "Imran S.", text: "Fixed fare from Ascot to Heathrow with no surge pricing after a busy event day.", rating: 5 },
    { name: "Charlotte P.", text: "Good Heathrow transfer from our Ascot hotel with enough luggage space.", rating: 5 },
    { name: "Daniel R.", text: "The live Heathrow checks and route FAQ were useful before leaving Ascot.", rating: 4.5 },
    { name: "Nina K.", text: "Reliable airport taxi from Ascot station to Heathrow.", rating: 4 },
  ],

  "/heathrow-to-ascot-taxi": [
    { name: "Rebecca W.", text: "Heathrow to Ascot Racecourse was easy to book and the driver tracked our delayed flight.", rating: 5 },
    { name: "Imran S.", text: "Fixed fare from Heathrow to Ascot with clear terminal pickup details and no surge pricing.", rating: 5 },
    { name: "Charlotte P.", text: "Good airport transfer to our Ascot hotel with space for bags and race day outfits.", rating: 5 },
    { name: "Daniel R.", text: "The live Heathrow checks and Ascot route notes were useful before we landed.", rating: 4.5 },
    { name: "Nina K.", text: "Reliable Heathrow pickup for Ascot station and a simple booking flow.", rating: 4 },
  ],

  "/henley-taxi": [
    { name: "Laura B.", text: "Henley town centre pickup was clear and the fixed fare helped us plan after the Regatta.", rating: 5 },
    { name: "Samir K.", text: "Useful Henley taxi page with station, riverside and Heathrow details in one place.", rating: 5 },
    { name: "Megan T.", text: "The MPV option worked well for bags and a hotel pickup near the river.", rating: 5 },
    { name: "Charles R.", text: "Clear guidance for Regatta pickup timing and the A4130 drop-off area.", rating: 4.5 },
    { name: "Nadia P.", text: "Good local Henley taxi page before booking our Heathrow transfer.", rating: 4 },
  ],

  "/henley-to-heathrow": [
    { name: "Laura B.", text: "Henley to Heathrow was easy to book and the pickup timing around town was clear.", rating: 5 },
    { name: "Samir K.", text: "Fixed fare from Henley-on-Thames to Heathrow with no surge pricing after a busy weekend.", rating: 5 },
    { name: "Megan T.", text: "Good Heathrow transfer from our riverside hotel with enough luggage space.", rating: 5 },
    { name: "Charles R.", text: "The live Heathrow checks and Regatta route notes were useful before leaving Henley.", rating: 4.5 },
    { name: "Nadia P.", text: "Reliable airport taxi from Henley station to Heathrow.", rating: 4 },
  ],

  "/heathrow-to-henley-taxi": [
    { name: "Laura B.", text: "Heathrow to Henley was smooth after our flight and the Regatta drop-off notes helped.", rating: 5 },
    { name: "Samir K.", text: "Fixed fare from Heathrow to Henley-on-Thames with clear terminal pickup timing.", rating: 5 },
    { name: "Megan T.", text: "Good Heathrow transfer to our riverside hotel with enough luggage space.", rating: 5 },
    { name: "Charles R.", text: "The live Heathrow checks and Henley route notes were useful before arrival.", rating: 4.5 },
    { name: "Nadia P.", text: "Reliable airport taxi from Heathrow to Henley station.", rating: 4 },
  ],

  "/cheapest-taxi-to-heathrow": [
    { name: "Sonia R.", text: "Saw fixed fare vs Uber vs black cab — picked the cheapest without surge risk.", rating: 5 },
    { name: "Hassan A.", text: "Great for groups with luggage; price certainty beat the train hassle.", rating: 5 },
    { name: "Megan J.", text: "Winner banner + stress grid made the decision instant.", rating: 5 },
    { name: "Victor T.", text: "Clear costs and reminders about Reserve fees. Booked confidently.", rating: 4 },
    { name: "Ivy L.", text: "Good tool; would like more vehicle photos.", rating: 3.5 },
  ],

  "/heathrow-fare-compare": [
    { name: "Arjun S.", text: "Side-by-side fares (fixed vs app vs meter) saved me £18 on my route.", rating: 5 },
    { name: "Marta P.", text: "Shows price risk and hassle — no guesswork before booking.", rating: 5 },
    { name: "Leo W.", text: "Loved the surge warning; locked a fixed fare for peace of mind.", rating: 5 },
    { name: "Becky F.", text: "Detailed and trustworthy; great for family trips with bags.", rating: 4 },
    { name: "Chloe V.", text: "Helpful, though the grid is dense on mobile.", rating: 3.5 },
  ],

  "/heathrow-fare-compare-lite": [
    { name: "Omar R.", text: "Quick price sense-check — helped me avoid overpaying.", rating: 5 },
    { name: "Sophie M.", text: "Simple and fast. Exactly what a ‘lite’ tool should be.", rating: 5 },
    { name: "Hamza K.", text: "Useful ranges and clear options — felt trustworthy.", rating: 4.5 },
    { name: "Lucy P.", text: "Nice tool. Would love to see more providers over time.", rating: 4 },
    { name: "Ben T.", text: "Good, but I wanted a bit more explanation on peak times.", rating: 3.5 },
  ],

  "/leave-for-heathrow": [
    { name: "Jenny Q.", text: "Timing tool was spot on — avoided both traffic stress and early arrival boredom.", rating: 5 },
    { name: "Rob K.", text: "Included bag check-in timing; felt realistic for T5.", rating: 5 },
    { name: "Amir F.", text: "Clear steps; paired it with fare compare for a smooth trip.", rating: 5 },
    { name: "Steph W.", text: "Good prompts, though I wish live traffic was baked in.", rating: 4 },
    { name: "Nina Y.", text: "Helpful, but I skimmed the longer notes.", rating: 3.5 },
  ],

  "/how-early-to-arrive-heathrow": [
    { name: "Isabel H.", text: "Great guidance for early flights — cut my airport waiting time.", rating: 5 },
    { name: "Caleb D.", text: "Factored luggage + kids; felt tailored instead of generic advice.", rating: 5 },
    { name: "Rita B.", text: "Matched airline advice and reduced my stress on departure day.", rating: 5 },
    { name: "Luke P.", text: "Clear, but I’d like an SMS reminder option.", rating: 4 },
    { name: "Olivia M.", text: "Good, a bit wordy on mobile.", rating: 3.5 },
  ],

  "/heathrow-arrival-pickup-time": [
    { name: "Dinesh K.", text: "Told me exactly when to set pickup — driver and I avoided waiting fees.", rating: 5 },
    { name: "Holly S.", text: "Factored bags and terminal changes; super practical.", rating: 5 },
    { name: "Rafael C.", text: "Loved the step-by-step; no more guessing on arrivals.", rating: 5 },
    { name: "Gwen L.", text: "Good prompts, would love a link to live baggage delays.", rating: 4 },
    { name: "Mara E.", text: "Helpful, but I skimmed to the summary.", rating: 3.5 },
  ],

  "/7-day-heathrow-parking-vs-taxi": [
    { name: "Anita J.", text: "Week-long parking vs taxi math saved us ~£60 and a lot of hassle.", rating: 5 },
    { name: "Joel M.", text: "Clear break-even numbers; chose taxi and avoided parking stress.", rating: 5 },
    { name: "Saira H.", text: "Great for family trips — luggage + meet-and-greet made sense.", rating: 5 },
    { name: "Chris N.", text: "Good comparison, would like EV charging info too.", rating: 4 },
    { name: "Emma P.", text: "Helpful, but graphs felt a bit small on my phone.", rating: 3.5 },
  ],

  "/minibus-hire": [
    { name: "Martin R.", text: "Group quote was cheaper than multiple taxis and zero hassle with luggage.", rating: 5 },
    { name: "Alina V.", text: "Door-to-door for 8 of us — way simpler than trains + bags.", rating: 5 },
    { name: "Craig T.", text: "Transparent pricing and quick confirmation for our team trip.", rating: 5 },
    { name: "Serena L.", text: "Smooth process; would love in-app chat with the driver.", rating: 4 },
    { name: "Yasmin K.", text: "Good experience overall; pickup time buffer could be clearer.", rating: 3.5 },
  ],

  "/coach-hire": [
    { name: "Rachel D.", text: "Coach quote for our Heathrow group was clear, quick and much easier than splitting into taxis.", rating: 5 },
    { name: "Imran S.", text: "Good support for a multi-stop company trip. The airport timing checks felt useful.", rating: 5 },
    { name: "Claire B.", text: "Transparent pricing and sensible questions for our school group luggage.", rating: 5 },
    { name: "Patrick H.", text: "Smooth process for a larger group; would like more coach photos in the next version.", rating: 4 },
    { name: "Nadia K.", text: "Helpful for planning, especially the Heathrow status before we confirmed timings.", rating: 4.5 },
  ],

  // ✅ Your tools (examples you mentioned)
  "/heathrow-dropoff-free-2026": [
    { name: "Hannah R.", text: "I had no idea there were free drop-off options — saved me money instantly.", rating: 5 },
    { name: "Usman A.", text: "The tool explained it clearly. Avoided the charge and the hassle.", rating: 5 },
    { name: "Grace L.", text: "Very useful — I would’ve paid without knowing the free alternative.", rating: 4.5 },
    { name: "Bilal K.", text: "Good info, but I still double-checked signage on arrival (which matched).", rating: 4 },
    { name: "Mark T.", text: "Helpful, but I’d love a bit more detail per terminal.", rating: 3.5 },
  ],

  "/heathrow-dropoff-calculator": [
    { name: "Hannah R.", text: "I had no idea there were free drop-off options — saved me money instantly.", rating: 5 },
    { name: "Usman A.", text: "The tool explained it clearly. Avoided the charge and the hassle.", rating: 5 },
    { name: "Grace L.", text: "Very useful — I would’ve paid without knowing the free alternative.", rating: 4.5 },
    { name: "Bilal K.", text: "Good info, but I still double-checked signage on arrival (which matched).", rating: 4 },
    { name: "Mark T.", text: "Helpful, but I’d love a bit more detail per terminal.", rating: 3.5 },
  ],

  "/heathrow-dropoff": [
    { name: "Hannah R.", text: "I had no idea there were free drop-off options — saved me money instantly.", rating: 5 },
    { name: "Usman A.", text: "The tool explained it clearly. Avoided the charge and the hassle.", rating: 5 },
    { name: "Grace L.", text: "Very useful — I would’ve paid without knowing the free alternative.", rating: 4.5 },
    { name: "Bilal K.", text: "Good info, but I still double-checked signage on arrival (which matched).", rating: 4 },
    { name: "Mark T.", text: "Helpful, but I’d love a bit more detail per terminal.", rating: 3.5 },
  ],

  "/heathrow-blue-badge-dropoff": [
    { name: "Shazia M.", text: "I didn’t know you need to register Blue Badge for Heathrow — this saved me a fine.", rating: 5 },
    { name: "David P.", text: "Clear steps and reminders. Exactly what I needed before the trip.", rating: 5 },
    { name: "Amina S.", text: "Simple and respectful explanation — made it less stressful.", rating: 4.5 },
    { name: "Jason N.", text: "Good guidance. Registration bit could be made even more prominent.", rating: 4 },
    { name: "Linda C.", text: "Helpful overall, just wish I’d found it earlier.", rating: 3.5 },
  ],

  "/legoland-budget-planner": [
    { name: "Hannah P.", text: "Planning 18 Mar — this tool showed Legoland was closed that day. Saved us a wasted trip.", rating: 5 },
    { name: "Jake L.", text: "From Marlow with kids: taxi was actually best on cost and hassle. Didn’t expect that.", rating: 5 },
    { name: "Maria S.", text: "Loved the ‘one answer’ card. Tickets + taxi vs train in one go.", rating: 4.5 },
    { name: "Ollie W.", text: "Told me parking queues + 9-min walk upfront. Drove with a stroller and it was accurate.", rating: 4.5 },
    { name: "Siobhan D.", text: "Seeing live open/close and ‘from’ price per date made planning easy.", rating: 5 },
  ],

  "/thorpepark-budget-planner": [
    { name: "Leanne C.", text: "The Waterloo train bit was spot on. Staines bus after that was easy to understand.", rating: 5 },
    { name: "Ryan T.", text: "Really liked seeing live taxi prices against live rail fares. Made the choice much easier.", rating: 5 },
    { name: "Megan B.", text: "Parking price and rules were clear, so we just drove and stopped second-guessing it.", rating: 5 },
    { name: "Callum P.", text: "Leave-home time was genuinely useful. We left when it said and got in without rushing.", rating: 4.5 },
    { name: "Sophie W.", text: "Weather mattered loads for us, so having that in the plan was a nice touch.", rating: 4 },
  ],

  "/legoland-vs-thorpe-park": [
    { name: "Natalie F.", text: "Side-by-side comparison made it obvious Thorpe was the better shout for our teenagers.", rating: 5 },
    { name: "Ben R.", text: "Legoland was closed on 15 April, so we switched to Thorpe. This page made the decision for us.", rating: 5 },
    { name: "Aisha K.", text: "Price was the real factor for us and this compared everything properly in one go.", rating: 5 },
    { name: "Tom H.", text: "Really handy seeing train, taxi and driving next to each other instead of jumping between pages.", rating: 4.5 },
    { name: "Rachel D.", text: "We were looking at Easter weekend and the ticket differences were actually useful to see.", rating: 4 },
  ],

  "/heathrow-dropoff-vs-short-stay": [
    { name: "Rehan A.", text: "Didn’t realise Short Stay can be cheaper than drop-off for certain durations — great tool.", rating: 5 },
    { name: "Chloe W.", text: "Made the decision easy. The ‘recommended option’ was spot on.", rating: 5 },
    { name: "Imran K.", text: "Loved the breakdown — cost + convenience in one place.", rating: 4.5 },
    { name: "Paul S.", text: "Very useful. I’d like a quick ‘family with bags’ option too.", rating: 4 },
    { name: "Nadia H.", text: "Good comparison, took me a minute to understand the assumptions.", rating: 3.5 },
  ],

  "/gatwick-dropoff": [
    { name: "Sarah M.", text: "Didn’t realise Gatwick had a £10 minimum. This saved me paying for no reason.", rating: 5 },
    { name: "Imran K.", text: "Clear comparison between drop-off and Long Stay. Ended up parking free and using the shuttle.", rating: 5 },
    { name: "Olivia P.", text: "The calculator made it obvious when Short Stay was cheaper than the forecourt.", rating: 4.5 },
    { name: "Daniel W.", text: "Helpful warning about paying by midnight — avoided a PCN.", rating: 4.5 },
    { name: "Rachel T.", text: "Good advice overall. Shuttle time was accurate when I tested it.", rating: 4 },
  ],

  "/gatwick-dropoff-calculator": [
    { name: "James R.", text: "Prices updated instantly as I changed minutes — very handy.", rating: 5 },
    { name: "Ayesha N.", text: "Loved seeing when drop-off stopped being worth it.", rating: 5 },
    { name: "Tom B.", text: "Helped me decide between Short Stay and Long Stay in seconds.", rating: 4.5 },
    { name: "Nina L.", text: "Clear layout and matched the official Gatwick prices.", rating: 4 },
  ],

  "/stansted-dropoff": [
    { name: "Kevin S.", text: "Didn’t realise Stansted jumps straight to £25 after 15 minutes. This warned me in time.", rating: 5 },
    { name: "Farah H.", text: "The Mid Stay free hour wasn’t obvious on the airport site — very useful.", rating: 5 },
    { name: "Luke D.", text: "Clear advice on when Express Set Down stops making sense.", rating: 4.5 },
    { name: "Priya M.", text: "Avoided a £25 charge by switching to Mid Stay.", rating: 4.5 },
    { name: "Alex J.", text: "Accurate and simple. Saved me stress at drop-off.", rating: 4 },
  ],

  "/stansted-dropoff-calculator": [
    { name: "Ben T.", text: "The minute-by-minute pricing made the £25 jump very clear.", rating: 5 },
    { name: "Hassan A.", text: "Easy to see when Mid Stay became the best option.", rating: 5 },
    { name: "Emma C.", text: "Matched what I saw on signs — reassuring.", rating: 4.5 },
  ],

  "/heathrow-fare-compare-lite": [
    { name: "Omar R.", text: "Quick price sense-check — helped me avoid overpaying.", rating: 5 },
    { name: "Sophie M.", text: "Simple and fast. Exactly what a ‘lite’ tool should be.", rating: 5 },
    { name: "Hamza K.", text: "Useful ranges and clear options — felt trustworthy.", rating: 4.5 },
    { name: "Lucy P.", text: "Nice tool. Would love to see more providers over time.", rating: 4 },
    { name: "Ben T.", text: "Good, but I wanted a bit more explanation on peak times.", rating: 3.5 },
  ],

  "/arrival-assistant": [
    { name: "Zara A.", text: "Landing at Heathrow felt less chaotic — the steps were practical.", rating: 5 },
    { name: "Daniel S.", text: "Helped me time things better (bags + pickup) and avoid rushing.", rating: 5 },
    { name: "Farah K.", text: "Loved the reminders — especially where to meet the driver.", rating: 4.5 },
    { name: "Chris P.", text: "Really helpful. Would be even better with terminal-specific tips.", rating: 4 },
    { name: "Maya L.", text: "Good overall, but I skimmed — maybe add a ‘quick mode’.", rating: 3.5 },
  ],

  "/arrival-assistant-student": [
    { name: "Hina S.", text: "Made my first UK arrival feel organised — immigration answers were clear.", rating: 5 },
    { name: "Leo M.", text: "Loved the CAS/eVisa reminders and the saved link. Felt ready before landing.", rating: 5 },
    { name: "Priya K.", text: "Queue estimates + what to carry for uni were spot on.", rating: 5 },
    { name: "Nadia J.", text: "Good student checklist. Would like more terminal-specific timings.", rating: 4 },
    { name: "Omar R.", text: "Helpful guide, I skimmed some bits but the checklists kept me on track.", rating: 3.5 },
  ],

  "/arrival-assistant-visitor": [
    { name: "Amina R.", text: "Clear visitor questions and customs tips — reduced my stress a lot.", rating: 5 },
    { name: "Jose P.", text: "ETA/visa reminders and baggage timing were really helpful.", rating: 5 },
    { name: "Sara L.", text: "Great for first-time visitors — liked the onward travel pointers.", rating: 5 },
    { name: "David W.", text: "Good guide. Would love more hotel/transport examples.", rating: 4 },
    { name: "Marta G.", text: "Helpful, but I skimmed parts. The saved checklist link was useful.", rating: 3.5 },
  ],

  "/arrival-assistant-worker": [
    { name: "Anita D.", text: "Right-to-work checklist + share code reminders were exactly what I needed.", rating: 5 },
    { name: "Samuel K.", text: "eVisa/BRP, bank, NI, and first-week tasks in one place — very useful.", rating: 5 },
    { name: "Nurse L.", text: "Perfect for my NHS start: queue estimate, docs, and employer-ready tips.", rating: 5 },
    { name: "Ola A.", text: "Great onboarding prep. Maybe add more payroll/bank examples.", rating: 4 },
    { name: "Chen Y.", text: "Helpful checklists; I skimmed some parts but the right-to-work steps were clear.", rating: 3.5 },
  ],

  "/train-vs-taxi": [
    {
      name: "Sam (Slough)",
      text: "From Slough to Heathrow it showed me I’d save a wedge with a fixed taxi — didn’t expect that and it was bang on.",
      rating: 5,
    },
    {
      name: "Amelia B.",
      text: "Birmingham trip: this actually proved National Rail was cheapest. Nice to see real data back up my hunch for once.",
      rating: 5,
    },
    {
      name: "Dan P.",
      text: "Best tool I’ve used — not a static blog. Real fares, real hassle scoring, felt like someone finally did the maths.",
      rating: 5,
    },
    {
      name: "Priya S.",
      text: "Trusted the numbers because they’re an official DRM partner — miles better than the guessy sites.",
      rating: 5,
    },
    {
      name: "Lewis T.",
      text: "Quick, clear, and actually tells you where you save. Saved me quids and a load of faff.",
      rating: 4.5,
    },
  ],

  // Heathrow-focused train vs taxi variants
  "/train-vs-taxi-elizabeth-line": [
    { name: "Holly B.", text: "Didn’t realise the Heathrow surcharge — this showed me the real Elizabeth Line total and the taxi wasn’t far off.", rating: 5 },
    { name: "James P.", text: "Eye-opener: with bags, the ‘cheap’ train was slower and barely cheaper than a fixed taxi.", rating: 5 },
    { name: "Sana R.", text: "Loved the hassle badge. TfL was cheapest but the walk looked grim, so I chose taxi.", rating: 5 },
    { name: "Tom K.", text: "Clear, quick, and no AI fluff — told me the train price and the catch.", rating: 4.5 },
    { name: "Leah C.", text: "Expected train to win big; turns out taxi split four ways was the same money without the lugging.", rating: 5 },
  ],

  "/heathrow-express-vs-taxi": [
    { name: "Matt J.", text: "HEX looked fastest, but the tool spelled out the Paddington faff. Taxi won for us.", rating: 5 },
    { name: "Priya D.", text: "Didn’t know HEX tickets spike same-day — glad I checked before paying more than a taxi.", rating: 5 },
    { name: "Owen S.", text: "T4 change note saved me hassle. Booked taxi instead of juggling bags on the train.", rating: 4.5 },
    { name: "Jules F.", text: "Nice balance: showed the train fare but also the ‘cheapest isn’t always easiest’ bit.", rating: 5 },
    { name: "Sara L.", text: "Short, human copy. Surprise that train could cost more than taxi for four of us.", rating: 5 },
  ],

  "/train-vs-taxi-heathrow": [
    { name: "Ricky A.", text: "Didn’t expect the train to be pricier than a taxi for 3 — this made it obvious.", rating: 5 },
    { name: "Fiona T.", text: "Straight talk on ticket costs and walk time. Booked taxi, saved my back.", rating: 5 },
    { name: "Arun M.", text: "Showed real fares, not guesses. The ‘best overall’ badge felt honest.", rating: 4.5 },
    { name: "Grace P.", text: "Quickly showed taxi vs rail with luggage notes — no waffle.", rating: 5 },
    { name: "Lewis B.", text: "Eye-opener: train wasn’t cheaper once bags + group were in. Glad I checked.", rating: 5 },
  ],

  "/cheapest-way-to-heathrow": [
    { name: "Sophie R.", text: "Cheapest vs best overall in one glance — TfL was cheap but the walk warning helped.", rating: 5 },
    { name: "Khalid N.", text: "Realised the ‘cheapest’ bus route would take ages. Booked taxi for a tenner more.", rating: 5 },
    { name: "Emma D.", text: "Short, casual copy. Train price surprised me — taxi split was better value.", rating: 5 },
    { name: "Leo G.", text: "Showed the catch on the cheapest option without feeling salesy.", rating: 4.5 },
    { name: "Marta S.", text: "Loved the cheapest-but-warning. Picked best overall and avoided a slog.", rating: 5 },
  ],

  // "/east-midlands-airport/live-journey-planner": [
  //   {
  //     name: "Laura P.",
  //     text: "Finally something that tells you when to leave - not just how long it takes. I used this for a 6am Ryanair flight from East Midlands and it factored in the Parkway transfer and early morning M1 traffic. It gave me a clear leave time instead of just a map duration. Felt much more reassuring than guessing.",
  //     rating: 5,
  //   },
  //   {
  //     name: "Imran S.",
  //     text: "Very useful for train vs taxi decisions. We were travelling as a group of four from Nottingham and the train looked cheaper at first. Once walking time and luggage were added, taxi made more sense. The comparison felt balanced and realistic.",
  //     rating: 5,
  //   },
  //   {
  //     name: "Charlotte M.",
  //     text: "Picked up a same-day rail disruption before I left. On 1 March there was disruption near Birmingham Moor Street affecting my route. The planner detected the extra journey time in hyper mode and adjusted my terminal arrival window. It was helpful seeing the risk clearly before setting off.",
  //     rating: 5,
  //   },
  //   {
  //     name: "Ravi K.",
  //     text: "Helpful the night before an early TUI flight. For my TOM7580 flight, it suggested the right time to leave and showed when check-in would open. I also received updates about M1 traffic conditions early that morning. SMS alerts for major issues would make it perfect.",
  //     rating: 4.5,
  //   },
  //   {
  //     name: "Helen W.",
  //     text: "Strong tool, still evolving. The monitoring and journey breakdown are impressive, especially how it tracks road and rail conditions. I think first-time users might benefit from a short explanation of how hyper monitoring works. Promising platform.",
  //     rating: 4,
  //   },
  // ],

  // Group and family
  "/train-vs-taxi-for-groups": [
    { name: "Team Oak", text: "Four of us split a taxi — cheaper than multiplying train fares. Bags stayed with us.", rating: 5 },
    { name: "Jen & pals", text: "Group fare maths done for me. Train price looked small until it multiplied by 5.", rating: 5 },
    { name: "Stag crew", text: "Hassle meter nailed it — no changes with luggage. Taxi won easily.", rating: 5 },
    { name: "Work trip", text: "Per-person vs total price side by side made the choice simple.", rating: 4.5 },
    { name: "Megan L.", text: "Didn’t realise under-3 changes and walks add up for groups — good callouts.", rating: 4.5 },
  ],

  "/train-vs-taxi-for-families": [
    { name: "Ellie & Sam", text: "2 adults + 2 kids (5–12): showed child fares and still taxi was calmer with bags.", rating: 5 },
    { name: "Nadia F.", text: "Under-5s free but the hassle score convinced me to skip the train with a pram.", rating: 5 },
    { name: "The Patels", text: "Loved the split: adults vs 5–15 fares sent to NR. Saved us over guessing.", rating: 5 },
    { name: "Connor J.", text: "Bag + walk penalties felt realistic. Taxi labelled ‘calmest’ was right.", rating: 4.5 },
    { name: "Lisa W.", text: "Didn’t know how kids’ tickets worked; this clarified it without salesy fluff.", rating: 5 },
  ],

  // Regional airport pages share a lightweight set (with two Gatwick mentions and one Manchester)
  "/train-vs-taxi-gatwick": [
    { name: "Anna (Gatwick)", text: "Surprised Gatwick train wasn’t always cheapest with bags — taxi beat it for us.", rating: 5 },
    { name: "Keiran P.", text: "Clear Gatwick drop-off notes and costs. Picked the fastest option easily.", rating: 4.5 },
    { name: "Maya V.", text: "Simple table: price, walk, changes. No fluff, just the answer.", rating: 5 },
    { name: "Dan (Manchester)", text: "Used it for MAN once — honest about when rail wins and when taxi does.", rating: 5 },
    { name: "Chloe R.", text: "Loved the hassle badge and quick comparison. Felt built by travellers.", rating: 4.5 },
  ],

  "/train-vs-taxi-manchester": [
    { name: "Anna (Gatwick)", text: "Surprised Gatwick train wasn’t always cheapest with bags — taxi beat it for us.", rating: 5 },
    { name: "Keiran P.", text: "Clear Gatwick drop-off notes and costs. Picked the fastest option easily.", rating: 4.5 },
    { name: "Maya V.", text: "Simple table: price, walk, changes. No fluff, just the answer.", rating: 5 },
    { name: "Dan (Manchester)", text: "Used it for MAN once — honest about when rail wins and when taxi does.", rating: 5 },
    { name: "Chloe R.", text: "Loved the hassle badge and quick comparison. Felt built by travellers.", rating: 4.5 },
  ],

  "/train-vs-taxi-edinburgh": [
    { name: "Anna (Gatwick)", text: "Surprised Gatwick train wasn’t always cheapest with bags — taxi beat it for us.", rating: 5 },
    { name: "Keiran P.", text: "Clear Gatwick drop-off notes and costs. Picked the fastest option easily.", rating: 4.5 },
    { name: "Maya V.", text: "Simple table: price, walk, changes. No fluff, just the answer.", rating: 5 },
    { name: "Dan (Manchester)", text: "Used it for MAN once — honest about when rail wins and when taxi does.", rating: 5 },
    { name: "Chloe R.", text: "Loved the hassle badge and quick comparison. Felt built by travellers.", rating: 4.5 },
  ],

  "/train-vs-taxi-birmingham": [
    { name: "Anna (Gatwick)", text: "Surprised Gatwick train wasn’t always cheapest with bags — taxi beat it for us.", rating: 5 },
    { name: "Keiran P.", text: "Clear Gatwick drop-off notes and costs. Picked the fastest option easily.", rating: 4.5 },
    { name: "Maya V.", text: "Simple table: price, walk, changes. No fluff, just the answer.", rating: 5 },
    { name: "Dan (Manchester)", text: "Used it for MAN once — honest about when rail wins and when taxi does.", rating: 5 },
    { name: "Chloe R.", text: "Loved the hassle badge and quick comparison. Felt built by travellers.", rating: 4.5 },
  ],

  "/train-vs-taxi-bristol": [
    { name: "Anna (Gatwick)", text: "Surprised Gatwick train wasn’t always cheapest with bags — taxi beat it for us.", rating: 5 },
    { name: "Keiran P.", text: "Clear Gatwick drop-off notes and costs. Picked the fastest option easily.", rating: 4.5 },
    { name: "Maya V.", text: "Simple table: price, walk, changes. No fluff, just the answer.", rating: 5 },
    { name: "Dan (Manchester)", text: "Used it for MAN once — honest about when rail wins and when taxi does.", rating: 5 },
    { name: "Chloe R.", text: "Loved the hassle badge and quick comparison. Felt built by travellers.", rating: 4.5 },
  ],

  "/train-vs-taxi-luton": [
    { name: "Anna (Gatwick)", text: "Surprised Gatwick train wasn’t always cheapest with bags — taxi beat it for us.", rating: 5 },
    { name: "Keiran P.", text: "Clear Gatwick drop-off notes and costs. Picked the fastest option easily.", rating: 4.5 },
    { name: "Maya V.", text: "Simple table: price, walk, changes. No fluff, just the answer.", rating: 5 },
    { name: "Dan (Manchester)", text: "Used it for MAN once — honest about when rail wins and when taxi does.", rating: 5 },
    { name: "Chloe R.", text: "Loved the hassle badge and quick comparison. Felt built by travellers.", rating: 4.5 },
  ],

  "/train-vs-taxi-stansted": [
    { name: "Anna (Gatwick)", text: "Surprised Gatwick train wasn’t always cheapest with bags — taxi beat it for us.", rating: 5 },
    { name: "Keiran P.", text: "Clear Gatwick drop-off notes and costs. Picked the fastest option easily.", rating: 4.5 },
    { name: "Maya V.", text: "Simple table: price, walk, changes. No fluff, just the answer.", rating: 5 },
    { name: "Dan (Manchester)", text: "Used it for MAN once — honest about when rail wins and when taxi does.", rating: 5 },
    { name: "Chloe R.", text: "Loved the hassle badge and quick comparison. Felt built by travellers.", rating: 4.5 },
  ],
};
